__turbopack_context__.v({
  "actions": "LxUS9q_actions",
  "amount": "LxUS9q_amount",
  "arrow": "LxUS9q_arrow",
  "body": "LxUS9q_body",
  "book": "LxUS9q_book",
  "card": "LxUS9q_card",
  "chevron": "LxUS9q_chevron",
  "deposit": "LxUS9q_deposit",
  "disclosure": "LxUS9q_disclosure",
  "figure": "LxUS9q_figure",
  "figureAffix": "LxUS9q_figureAffix",
  "lead": "LxUS9q_lead",
  "leadText": "LxUS9q_leadText",
  "price": "LxUS9q_price",
  "priceText": "LxUS9q_priceText",
  "range": "LxUS9q_range",
  "rangeInner": "LxUS9q_rangeInner",
  "soldOut": "LxUS9q_soldOut",
  "status": "LxUS9q_status",
  "toggle": "LxUS9q_toggle",
  "whatsapp": "LxUS9q_whatsapp",
  "whatsappMark": "LxUS9q_whatsappMark",
});
